import useGet from "../useGet";
import moment from "moment";
import { OrderHistoryRow } from "../../containers/OrderHistoryContainer/types";
import convertOrderStatusToStatusDescription from "../../utils/convertOrderStatusToStatusDescription";

const useOrders = (
  page: number,
  rowsPerPage: number,
  filter: any,
  sortBy?: string,
  sortDirection?: string,
  dependencies?: any[]
) => {
  let statusQueryParams = "";

  statusQueryParams =
    filter.status && filter.status.length > 0
      ? filter.status && filter.status.map((x: any) => `&status=${x}`).join("")
      : "&status=";

  let filtersPath = `&type=${filter.type}&currency=${
    filter.currency
  }&branch=${encodeURIComponent(
    filter.branchName
  )}${statusQueryParams}&date-required-from=${
    filter.dateRequiredFrom
  }&date-required-to=${filter.dateRequiredTo}&date-ordered-from=${
    filter.datePlacedFrom
  }&date-ordered-to=${filter.datePlacedTo}`;

  let path = "";
  if (sortBy !== null && sortDirection !== null) {
    path = `/api/Orders?page=${page}&page-size=${rowsPerPage}&sort-by=${sortBy}&sort-direction=${sortDirection}${filtersPath}&ts=${new Date().getTime()}`;
  } else {
    path = `/api/Orders?page=${page}&page-size=${rowsPerPage}${filtersPath}&ts=${new Date().getTime()}`;
  }

  const { value, loading } = useGet(
    path,
    "Unable to read orders",
    [],
    dependencies,
    undefined,
    undefined,
    (v: any) => v && typeof v === "object"
  );

  return {
    orders:
      value.results &&
      (value.results.map(
        (item: any) =>
          ({
            type: item.type,
            branch: item.branch,
            currencyRegion: item.currencyRegion,
            currencySymbol: item.currencySymbol,
            currencyCode: item.currencyCode,
            currencyName: item.currencyName,
            currencyAmount: item.currencyAmount,
            comments: item.comments,
            dateOrdered: moment(item.dateOrdered).format("DD/MM/YYYY"),
            dateRequired: moment(item.dateRequired).format("DD/MM/YYYY"),
            status: convertOrderStatusToStatusDescription(item.status),
            id: item.id
          } as OrderHistoryRow)
      ) as OrderHistoryRow[]),
    ordersLoading: loading,
    currentPage: value.currentPage,
    pageSize: value.pageSize,
    pageCount: value.pageCount,
    totalCount: value.totalCount
  };
};

export default useOrders;
